import React from 'react';
import { useTranslation } from 'react-i18next';
import { translations } from 'translations';
import { PRIVACY_POLICY_URL, TERMS_AND_CONDITIONS_URL } from 'components/forms/AuthForms/SignupForm/helpers/url-helpers';

export const LegalNotice: React.FC = () => {
  const { t } = useTranslation();

  return (
    <p className="w-full max-w-[440px] text-center text-[9px] sm:text-[10px] text-gray-300 leading-relaxed opacity-80">
      <span>{t('auth.legalWarning', 'Uso sujeto a los')} </span>
      <a 
        href={TERMS_AND_CONDITIONS_URL} 
        target="_blank" 
        rel="noopener noreferrer"
        className="font-bold hover:underline"
      >
        {t(translations.COMMON.TERMS)}
      </a>
      <span> {t('common.and', '&')} </span>
      <a 
        href={PRIVACY_POLICY_URL} 
        target="_blank" 
        rel="noopener noreferrer"
        className="font-bold hover:underline"
      >
        {t(translations.COMMON.PRIVACY_POLICY)}
      </a>
    </p>
  );
};
